import * as React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import PopularTourSlider from "./poplarTourSlider"
import CaptivatingFactSlider from "./captivatingFactSlider"

const PrefectureItem = ({ blok }) => {
  // console.log(blok)

  return (
    <main {...storyblokEditable(blok)} key={blok._uid}>
      <div className="prefecture-description p-4 border-t md:border-b md:border-t-0">
        <div className="">
          <h3 className="text-2xl font-bold inline-block capitalize underline-yellow">
            {/* <img className="w-[14px] h-[25px] mr-2 mb-3 inline-block" src="/icons/prefecture-back-slash.svg" alt=""/> */}
            {blok.prefecture}
            {/* <img className="w-[14px] h-[25px] ml-2 mb-3 inline-block" src="/icons/prefecture-slash.svg" alt=""/> */}
          </h3>
          <p className="text-md inline-block ml-2">({blok.kanji} {blok.phonic})</p>
        </div>
        <h4 className="font-serif font-bold text-md my-2">
          {blok.aka}
        </h4>
        <div className="mt-5 mb-6" dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}} />
      </div>

      <div className="flex flex-wrap">
        <div className="captivating-facts p-4 w-full border-t md:w-1/2 md:border-t-0 md:border-r">
          
          <CaptivatingFactSlider blok={blok} />
        </div>
        <div className="popular-tours p-4 w-full border-t md:w-1/2 md:border-t-0">
          
          <PopularTourSlider blok={blok} />
        </div>
      </div>
    </main>
  )
};

export default PrefectureItem;
